import { Divider, Paper, useTheme } from '@mui/material';

import { NoteListItems } from './components/NoteListItems';
import { ViewOptionsSection } from './components/ViewOptionsSection';
import { useNoteListSidebar } from './useNoteListSidebar';

export const NoteListSidebar = ({ leftWidth }: { leftWidth: number }) => {
  const theme = useTheme();

  const { notes, isAnnotationWorkspaceLoading, filterOptions } = useNoteListSidebar();
  return (
    <Paper
      elevation={0}
      sx={{
        width: leftWidth,
        height: 'calc(100vh - 51px)',
        maxHeight: 'calc(100vh - 51px)',
        borderRight: `1px solid ${theme.palette.divider}`,
        position: 'sticky',
        top: 0,
        borderRadius: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <ViewOptionsSection filterOptions={filterOptions} />
      <Divider />
      <NoteListItems notes={notes} isAnnotationWorkspaceLoading={isAnnotationWorkspaceLoading} />
    </Paper>
  );
};
